import apiClient from './client'

export type MaterialCategory = 'requirements' | 'standards' | 'rules' | 'general'

export interface Material {
  id: string
  assistant_id: string
  organization_id: string
  title: string
  content: string
  category: MaterialCategory
  sort_order: number
  tags: string[]
  created_by?: string
  created_at: string
  updated_at: string
}

export interface CreateMaterialRequest {
  title: string
  content: string
  category: MaterialCategory
  tags: string[]
}

export interface UpdateMaterialRequest {
  title: string
  content: string
  category: MaterialCategory
  tags: string[]
}

export const CATEGORY_CONFIG: Record<MaterialCategory, { icon: string; label: string; color: string }> = {
  requirements: { icon: '📋', label: 'Требования', color: '#F57C00' },
  standards: { icon: '📊', label: 'Нормативы', color: '#E65100' },
  rules: { icon: '📜', label: 'Правила', color: '#FB8C00' },
  general: { icon: '📝', label: 'Общее', color: '#FF9800' },
}

export const materialsApi = {
  getTrash: async (assistantId: string): Promise<Material[]> => {
    const { data } = await apiClient.get(`/assistants/${assistantId}/materials/trash`)
    return data
  },
  restore: async (id: string): Promise<Material> => {
    const { data } = await apiClient.post(`/materials/${id}/restore`)
    return data
  },
  getByAssistantId: async (assistantId: string): Promise<Material[]> => {
    const { data } = await apiClient.get(`/assistants/${assistantId}/materials`)
    return data
  },

  getById: async (materialId: string): Promise<Material> => {
    const { data } = await apiClient.get(`/materials/${materialId}`)
    return data
  },

  create: async (assistantId: string, req: CreateMaterialRequest): Promise<Material> => {
    const { data } = await apiClient.post(`/assistants/${assistantId}/materials`, req)
    return data
  },

  update: async (materialId: string, req: UpdateMaterialRequest): Promise<Material> => {
    const { data } = await apiClient.put(`/materials/${materialId}`, req)
    return data
  },

  delete: async (materialId: string): Promise<void> => {
    await apiClient.delete(`/materials/${materialId}`)
  },
}
